export const SYNC_UNITS = '@@units/sync'

export const UPDATE_UNITS = '@@units/update'

export const UPDATE_UNIT_NAME = '@@units/updateUnitName'

export const RESET_UNITS = '@@units/reset'
